import ComponentBasePrototype from 'ComponentBasePrototype';

export default class Notification extends ComponentBasePrototype {

  build() {
    this.deleteDiv = this.node.find('.deleteNotification');
    this.bindListeners();
  }

  bindListeners() {
    this.eventBus.subscribe(this, 'close', this.onClose, this.id);
    this.eventBus.subscribe(this, 'open', this.onOpen, this.id);

    // Bind click handler
    this.deleteDiv.on('click', () => this.onClose());
  }

  onClose() {
    this.node.addClass('notification--deleted');
  }

  onOpen() {
    this.node.removeClass('notification--deleted');
  }
}
